module.exports = __webpack_public_path__ + "logo2.png?b9bb160cfb4422e14d03f17f15faace6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo2.png
// module id = 33
// module chunks = 2